import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const TermServices = async () => {
  try {
    return await getData(`/website/termsofservice/termsofservice`);
  } catch (error) {
    console.log(error);
  }
};